module.exports = __webpack_public_path__ + "img/places.8f20a4c6.svg";